import React from 'react';

import * as Sentry from '@sentry/react';
import {
  QueryClientProvider,
  QueryErrorResetBoundary,
} from '@tanstack/react-query';

import { queryClient } from '@api/api.queryClient';
import { FullPageLoadingSpinner } from '@components/spinners';
import {
  AuthProvider,
  UnderMaintenance,
  CacheBuster,
} from '@components/utilComponents';
import { Error500Page } from '@pages/Service';

const RouterProvider = React.lazy(async () => {
  const [{ RouterProvider }, { router }] = await Promise.all([
    import('@navigation/RouterProvider'),
    import('@navigation/router'),
  ]);

  // Возвращаем компонент с переданным router
  return {
    default: () => <RouterProvider router={router} />,
  };
});

// Create a client
export const App = () => {
  return (
    <Sentry.ErrorBoundary fallback={<Error500Page />}>
      <React.StrictMode>
        <CacheBuster
          loadingComponent={<FullPageLoadingSpinner backdrop={false} />}
        >
          <QueryClientProvider client={queryClient}>
            <QueryErrorResetBoundary>
              {({ reset }) => (
                <Sentry.ErrorBoundary
                  fallback={<UnderMaintenance />}
                  onReset={reset}
                >
                  {/* Suspense покрывает загрузку AuthProvider + RouterProvider */}
                  <React.Suspense
                    fallback={<FullPageLoadingSpinner backdrop={false} />}
                  >
                    <AuthProvider>
                      <RouterProvider />
                    </AuthProvider>
                  </React.Suspense>
                </Sentry.ErrorBoundary>
              )}
            </QueryErrorResetBoundary>
          </QueryClientProvider>
        </CacheBuster>
      </React.StrictMode>
    </Sentry.ErrorBoundary>
  );
};
